import React, { useMemo } from 'react';
import {
  createUltimatePagination,
  UltimatePaginationProps,
} from 'react-ultimate-pagination';
import {
  Ellipsis,
  FirstPageLink,
  LastPageLink,
  NextPageLink,
  Page,
  PreviousPageLink,
  Wrapper,
} from './pages';
import { PaginationRestrictionProvider } from './pagination-restriction-context';

const itemTypeToComponent = {
  PAGE: Page,
  ELLIPSIS: Ellipsis,
  FIRST_PAGE_LINK: FirstPageLink,
  PREVIOUS_PAGE_LINK: PreviousPageLink,
  NEXT_PAGE_LINK: NextPageLink,
  LAST_PAGE_LINK: LastPageLink,
};

const UltimatePagination = createUltimatePagination({
  itemTypeToComponent,
  WrapperComponent: Wrapper,
});

export type PaginationProps = Omit<UltimatePaginationProps, 'disabled'> & {
  maxAllowedPage?: number;
  restrictionTooltip?: string;
};

// check default configurations here:
// https://github.com/ultimate-pagination/react-ultimate-pagination#usage

const Pagination: React.FC<PaginationProps> = (props) => {
  const {
    totalPages,
    currentPage,
    maxAllowedPage,
    restrictionTooltip,
    ...rest
  } = props;

  const restrictionValue = useMemo(
    () => ({ maxAllowedPage, restrictionTooltip }),
    [maxAllowedPage, restrictionTooltip],
  );

  if (currentPage === null || currentPage > totalPages) {
    return null;
  }

  return (
    <PaginationRestrictionProvider value={restrictionValue}>
      <UltimatePagination
        {...rest}
        currentPage={currentPage}
        totalPages={totalPages}
        disabled={totalPages === 0}
      />
    </PaginationRestrictionProvider>
  );
};

Pagination.defaultProps = {
  hideFirstAndLastPageLinks: true,
};

export default Pagination;
